import { Message } from '@messageformat/react';
import { IconBuy } from '@op/opds.opux-icons/action';
import { IconHousing } from '@op/opds.opux-icons/expenses';
import { IconForex, IconInterest, IconStock } from '@op/opds.opux-icons/finance';
import {
  IconDevicePhone,
  IconDoctor,
  IconElectricity,
  IconRepair,
  IconTrain,
} from '@op/opds.opux-icons/misc';

export const optionsDomestic = [
  {
    id: 1,
    name: <Message id="course7.task2.tab1.stock1.name" />,
    description: <Message id="course7.task2.tab1.stock1.description" />,
    icon: <IconDevicePhone size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab1.stock1.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab1.stock1.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab1.stock1.field" />,
        share: 100,
      },
    ],
  },
  {
    id: 2,
    name: <Message id="course7.task2.tab1.stock2.name" />,
    description: <Message id="course7.task2.tab1.stock2.description" />,
    icon: <IconHousing size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab1.stock2.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab1.stock2.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab1.stock2.field" />,
        share: 100,
      },
    ],
  },
  {
    id: 3,
    name: <Message id="course7.task2.tab1.stock3.name" />,
    description: <Message id="course7.task2.tab1.stock3.description" />,
    icon: <IconRepair size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab1.stock3.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab1.stock3.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab1.stock3.field" />,
        share: 100,
      },
    ],
  },
  {
    id: 4,
    name: <Message id="course7.task2.tab1.stock4.name" />,
    description: <Message id="course7.task2.tab1.stock4.description" />,
    icon: <IconDoctor size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab1.stock4.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab1.stock4.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab1.stock4.field" />,
        share: 100,
      },
    ],
  },
  {
    id: 5,
    name: <Message id="course7.task2.tab1.stock5.name" />,
    description: <Message id="course7.task2.tab1.stock5.description" />,
    icon: <IconBuy size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab1.stock5.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab1.stock5.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab1.stock5.field" />,
        share: 100,
      },
    ],
  },
];

export const optionsForeign = [
  {
    id: 6,
    name: <Message id="course7.task2.tab2.stock1.name" />,
    description: <Message id="course7.task2.tab2.stock1.description" />,
    icon: <IconDevicePhone size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab2.stock1.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab2.stock1.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab2.stock1.field" />,
        share: 100,
      },
    ],
  },
  {
    id: 7,
    name: <Message id="course7.task2.tab2.stock2.name" />,
    description: <Message id="course7.task2.tab2.stock2.description" />,
    icon: <IconTrain size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab2.stock2.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab2.stock2.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab2.stock2.field" />,
        share: 100,
      },
    ],
  },
  {
    id: 8,
    name: <Message id="course7.task2.tab2.stock3.name" />,
    description: <Message id="course7.task2.tab2.stock3.description" />,
    icon: <IconForex size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab2.stock3.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab2.stock3.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab2.stock3.field" />,
        share: 100,
      },
    ],
  },
  {
    id: 9,
    name: <Message id="course7.task2.tab2.stock4.name" />,
    description: <Message id="course7.task2.tab2.stock4.description" />,
    icon: <IconElectricity size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab2.stock4.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab2.stock4.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab2.stock4.field" />,
        share: 100,
      },
    ],
  },
  {
    id: 10,
    name: <Message id="course7.task2.tab2.stock5.name" />,
    description: <Message id="course7.task2.tab2.stock5.description" />,
    icon: <IconBuy size="large" />,
    instruments: [
      {
        name: <Message id="course7.task2.tab2.stock5.type" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task2.tab2.stock5.location" />,
        share: 100,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task2.tab2.stock5.field" />,
        share: 100,
      },
    ],
  },
];

export const optionsFunds = [
  {
    id: 1,
    name: <Message id="course7.task3.tab1.fund1.name" />,
    icon: <IconStock size="large" />,
    instruments: [
      {
        name: <Message id="course7.task3.tab1.instruments.stock_funds" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task3.tab1.locations.united_states" />,
        share: 68.7,
      },
      {
        name: <Message id="course7.task3.tab1.locations.great_britain" />,
        share: 4.3,
      },
      {
        name: <Message id="course7.task3.tab1.locations.canada" />,
        share: 3.5,
      },
      {
        name: <Message id="course7.task3.tab1.locations.france" />,
        share: 3.4,
      },
      {
        name: <Message id="course7.task3.tab1.locations.japan" />,
        share: 3.1,
      },
      {
        name: <Message id="course7.task3.tab1.locations.switzerland" />,
        share: 3.0,
      },
      {
        name: <Message id="course7.task3.tab1.locations.germany" />,
        share: 2.2,
      },
      {
        name: <Message id="course7.task3.tab1.locations.netherlands" />,
        share: 1.7,
      },
      {
        name: <Message id="course7.task3.tab1.locations.denmark" />,
        share: 1.6,
      },
      {
        name: <Message id="course7.task3.tab1.locations.china" />,
        share: 1.3,
      },
      {
        name: <Message id="course7.task3.tab1.locations.india" />,
        share: 1.1,
      },
      {
        name: <Message id="course7.task3.tab1.locations.other" />,
        share: 6.1,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task3.tab1.fields.energy" />,
        share: 3.6,
      },
      {
        name: <Message id="course7.task3.tab1.fields.information_technology" />,
        share: 27.8,
      },
      {
        name: <Message id="course7.task3.tab1.fields.real_estate" />,
        share: 2.2,
      },
      {
        name: <Message id="course7.task3.tab1.fields.consumer_goods" />,
        share: 11.3,
      },
      {
        name: <Message id="course7.task3.tab1.fields.basic_industry" />,
        share: 3.6,
      },
      {
        name: <Message id="course7.task3.tab1.fields.groceries" />,
        share: 5.7,
      },
      {
        name: <Message id="course7.task3.tab1.fields.funding" />,
        share: 14.2,
      },
      {
        name: <Message id="course7.task3.tab1.fields.manufacturing" />,
        share: 10.3,
      },
      {
        name: <Message id="course7.task3.tab1.fields.healthcare" />,
        share: 13.5,
      },
      {
        name: <Message id="course7.task3.tab1.fields.communication_services" />,
        share: 6.4,
      },
      {
        name: <Message id="course7.task3.tab1.fields.community_services" />,
        share: 2.1,
      },
    ],
  },
  {
    id: 2,
    name: <Message id="course7.task3.tab1.fund2.name" />,
    icon: <IconStock size="large" />,
    instruments: [
      {
        name: <Message id="course7.task3.tab1.instruments.stock_funds" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task3.tab1.locations.finland" />,
        share: 96.4,
      },
      {
        name: <Message id="course7.task3.tab1.locations.denmark" />,
        share: 2.1,
      },
      {
        name: <Message id="course7.task3.tab1.locations.sweden" />,
        share: 1.3,
      },
      {
        name: <Message id="course7.task3.tab1.locations.bermuda" />,
        share: 0.6,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task3.tab1.fields.energy" />,
        share: 3.8,
      },
      {
        name: <Message id="course7.task3.tab1.fields.information_technology" />,
        share: 10.2,
      },
      {
        name: <Message id="course7.task3.tab1.fields.real_estate" />,
        share: 3.5,
      },
      {
        name: <Message id="course7.task3.tab1.fields.consumer_goods" />,
        share: 2.1,
      },
      {
        name: <Message id="course7.task3.tab1.fields.basic_industry" />,
        share: 15.6,
      },
      {
        name: <Message id="course7.task3.tab1.fields.groceries" />,
        share: 8.5,
      },
      {
        name: <Message id="course7.task3.tab1.fields.funding" />,
        share: 17.4,
      },
      {
        name: <Message id="course7.task3.tab1.fields.manufacturing" />,
        share: 25.3,
      },
      {
        name: <Message id="course7.task3.tab1.fields.healthcare" />,
        share: 6.0,
      },
      {
        name: <Message id="course7.task3.tab1.fields.communication_services" />,
        share: 5.4,
      },
      {
        name: <Message id="course7.task3.tab1.fields.community_services" />,
        share: 2.6,
      },
    ],
  },
  {
    id: 3,
    name: <Message id="course7.task3.tab1.fund3.name" />,
    icon: <IconStock size="large" />,
    instruments: [
      {
        name: <Message id="course7.task3.tab1.instruments.stock_funds" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task3.tab1.locations.united_states" />,
        share: 95.2,
      },
      {
        name: <Message id="course7.task3.tab1.locations.canada" />,
        share: 3.8,
      },
      {
        name: <Message id="course7.task3.tab1.locations.great_britain" />,
        share: 0.6,
      },
      {
        name: <Message id="course7.task3.tab1.locations.ireland" />,
        share: 0.3,
      },
      {
        name: <Message id="course7.task3.tab1.locations.netherlands" />,
        share: 0.1,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task3.tab1.fields.energy" />,
        share: 2.4,
      },
      {
        name: <Message id="course7.task3.tab1.fields.information_technology" />,
        share: 33.0,
      },
      {
        name: <Message id="course7.task3.tab1.fields.real_estate" />,
        share: 2.1,
      },
      {
        name: <Message id="course7.task3.tab1.fields.consumer_goods" />,
        share: 11.3,
      },
      {
        name: <Message id="course7.task3.tab1.fields.basic_industry" />,
        share: 2.6,
      },
      {
        name: <Message id="course7.task3.tab1.fields.groceries" />,
        share: 3.1,
      },
      {
        name: <Message id="course7.task3.tab1.fields.funding" />,
        share: 15.5,
      },
      {
        name: <Message id="course7.task3.tab1.fields.manufacturing" />,
        share: 7.7,
      },
      {
        name: <Message id="course7.task3.tab1.fields.healthcare" />,
        share: 11.6,
      },
      {
        name: <Message id="course7.task3.tab1.fields.communication_services" />,
        share: 9.2,
      },
      {
        name: <Message id="course7.task3.tab1.fields.community_services" />,
        share: 1.5,
      },
    ],
  },
  {
    id: 4,
    name: <Message id="course7.task3.tab1.fund4.name" />,
    icon: <IconInterest size="large" />,
    instruments: [
      {
        name: <Message id="course7.task3.tab1.instruments.interest_funds" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task3.tab1.locations.united_states" />,
        share: 9.3,
      },
      {
        name: <Message id="course7.task3.tab1.locations.france" />,
        share: 8.4,
      },
      {
        name: <Message id="course7.task3.tab1.locations.germany" />,
        share: 5.2,
      },
      {
        name: <Message id="course7.task3.tab1.locations.netherlands" />,
        share: 4.0,
      },
      {
        name: <Message id="course7.task3.tab1.locations.sweden" />,
        share: 3.8,
      },
      {
        name: <Message id="course7.task3.tab1.locations.brazil" />,
        share: 3.8,
      },
      {
        name: <Message id="course7.task3.tab1.locations.china" />,
        share: 3.3,
      },
      {
        name: <Message id="course7.task3.tab1.locations.india" />,
        share: 3.1,
      },
      {
        name: <Message id="course7.task3.tab1.locations.chile" />,
        share: 3.0,
      },
      {
        name: <Message id="course7.task3.tab1.locations.italy" />,
        share: 3.0,
      },
      {
        name: <Message id="course7.task3.tab1.locations.other" />,
        share: 53.1,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task3.tab1.fields.government_loans" />,
        share: 0.2,
      },
      {
        name: <Message id="course7.task3.tab1.fields.emerging_markets" />,
        share: 31.0,
      },
      {
        name: <Message id="course7.task3.tab1.fields.cash" />,
        share: 5.6,
      },
      {
        name: <Message id="course7.task3.tab1.fields.other" />,
        share: 63.2,
      },
    ],
  },
  {
    id: 5,
    name: <Message id="course7.task3.tab1.fund5.name" />,
    icon: <IconStock size="large" />,
    instruments: [
      {
        name: <Message id="course7.task3.tab1.instruments.stock_funds" />,
        share: 100,
      },
    ],
    locations: [
      {
        name: <Message id="course7.task3.tab1.locations.india" />,
        share: 17.9,
      },
      {
        name: <Message id="course7.task3.tab1.locations.hongkong" />,
        share: 17.8,
      },
      {
        name: <Message id="course7.task3.tab1.locations.taiwan" />,
        share: 17.2,
      },
      {
        name: <Message id="course7.task3.tab1.locations.south_korea" />,
        share: 13.3,
      },
      {
        name: <Message id="course7.task3.tab1.locations.china" />,
        share: 7.5,
      },
      {
        name: <Message id="course7.task3.tab1.locations.south_africa" />,
        share: 4.1,
      },
      {
        name: <Message id="course7.task3.tab1.locations.brazil" />,
        share: 4.1,
      },
      {
        name: <Message id="course7.task3.tab1.locations.indonesia" />,
        share: 3.8,
      },
      {
        name: <Message id="course7.task3.tab1.locations.malaysia" />,
        share: 2.9,
      },
      {
        name: <Message id="course7.task3.tab1.locations.thailand" />,
        share: 2.8,
      },
      {
        name: <Message id="course7.task3.tab1.locations.saudiarabia" />,
        share: 2.3,
      },
      {
        name: <Message id="course7.task3.tab1.locations.other" />,
        share: 6.3,
      },
    ],
    fields: [
      {
        name: <Message id="course7.task3.tab1.fields.energy" />,
        share: 3.9,
      },
      {
        name: <Message id="course7.task3.tab1.fields.information_technology" />,
        share: 23.3,
      },
      {
        name: <Message id="course7.task3.tab1.fields.real_estate" />,
        share: 1.3,
      },
      {
        name: <Message id="course7.task3.tab1.fields.consumer_goods" />,
        share: 13.3,
      },
      {
        name: <Message id="course7.task3.tab1.fields.basic_industry" />,
        share: 9.9,
      },
      {
        name: <Message id="course7.task3.tab1.fields.groceries" />,
        share: 5.5,
      },
      {
        name: <Message id="course7.task3.tab1.fields.funding" />,
        share: 18.5,
      },
      {
        name: <Message id="course7.task3.tab1.fields.manufacturing" />,
        share: 7.1,
      },
      {
        name: <Message id="course7.task3.tab1.fields.healthcare" />,
        share: 2.5,
      },
      {
        name: <Message id="course7.task3.tab1.fields.communication_services" />,
        share: 13.2,
      },
      {
        name: <Message id="course7.task3.tab1.fields.community_services" />,
        share: 0.1,
      },
      {
        name: <Message id="course7.task3.tab1.fields.other" />,
        share: 1.4,
      },
    ],
  },
];
